export default "__VITE_ASSET__B7cWeK4t__"